export const assetsPath = '/images';
export const imagesPath = `${assetsPath}/images/`;
export const iconsPath = `${assetsPath}/icons/`;

export const ICONS = {
  download: iconsPath + 'download.svg',
  offerings: iconsPath + 'offerings.svg',
  caretDownBlack: iconsPath + 'caret-down-black.svg',
  checkMarkWhite: iconsPath + 'check-mark-white.svg',
  lockWhite: iconsPath + 'lock-white.svg',
  caretDown: iconsPath + 'caret-down.svg',
  lockGray: iconsPath + 'lock-gray.svg',
  menu: iconsPath + 'menu.svg',
  globeBlack: iconsPath + 'globe-black.svg',
  search: iconsPath + 'search.svg',
  searchThin: iconsPath + 'search-thin.svg',
  help: iconsPath + 'help.svg',
  folder: iconsPath + 'folder.svg',
  cubeOutlineBlack: iconsPath + 'cube-outline-black.svg',
  dashboard: iconsPath + 'dashboard.svg',
  plan: iconsPath + 'plan.svg',
  assignment: iconsPath + 'assignment.svg',
  book: iconsPath + 'book.svg',
  errorOutlined: iconsPath + 'error-outlined.svg',
  crossBlack: iconsPath + 'cross-black.svg',
  refresh: iconsPath + 'refresh.svg',
  spark: iconsPath + 'spark.svg',
  sparkDark: iconsPath + 'spark-dark.svg',
  deepSeek: iconsPath + 'deep-seek.svg',
  grok: iconsPath + 'grok.svg',
  perplexity: iconsPath + 'perplexity.svg',
  cross: iconsPath + 'cross.svg',
  comingSoon: iconsPath + 'coming-soon.svg',
  checkMarkGreen: iconsPath + 'check-mark-green.svg',
  error: iconsPath + 'error.svg',
  feedback: iconsPath + 'feedback.svg',
  request: iconsPath + 'request.svg',
  loadingSpinner: iconsPath + 'loading-spinner.svg',
  missingIcon: iconsPath + 'missing-icon.svg',
  arrowBackBlue: iconsPath + 'arrow-back-blue.svg',
  checkMark: iconsPath + 'check-mark.svg',
  tooltip: iconsPath + 'tooltip.svg',
  helpCircleOutline: iconsPath + 'help-circle-outline.svg',
  infoOutline: iconsPath + 'info-outline.svg',
  checkMarkNeutral: iconsPath + 'check-mark-neutral.svg',
  closeNeutral: iconsPath + 'close-neutral.svg',
  triangle: iconsPath + 'indicator-triangle.svg',
  globe: iconsPath + 'globe.svg',
  users: iconsPath + 'users.svg',
  flag: iconsPath + 'flag.svg',
  link: iconsPath + 'link.svg',
  arrowUp: iconsPath + 'arrow-up.svg',
  arrowDown: iconsPath + 'arrow-down.svg',
  listStar: iconsPath + 'list-star.svg',
  listEdit: iconsPath + 'list-edit.svg',
  listCheckmark: iconsPath + 'list-checkmark.svg',
  progressActivity: iconsPath + 'progress-activity.svg',
  checkCircle: iconsPath + 'check-circle.svg',
  editPencil: iconsPath + 'edit-pencil.svg',
  warningTriangle: iconsPath + 'warning-triangle.svg',
  business: iconsPath + 'business.svg',
  chatGPT: iconsPath + 'chatgpt.svg',
  claude: iconsPath + 'claude.svg',
  gemini: iconsPath + 'gemini.svg',
  mistral: iconsPath + 'mistral.svg',
  trashcan: iconsPath + 'trashcan.svg',
  newTab: iconsPath + 'new-tab.svg',
  verticalDots: iconsPath + 'vertical-dots.svg',
  arrowBack: iconsPath + 'arrow-back.svg',
  chevronLeft: iconsPath + 'chevron-left.svg',
  chevronRight: iconsPath + 'chevron-right.svg',
  cubeOutline: iconsPath + 'cube-outline.svg',
  aiSerchLogo: iconsPath + 'ai-search-logo.svg',
  xoviAILogo: iconsPath + 'xovi-ai-logo.svg',
  rivaAILogo: iconsPath + 'riva-ai-logo.svg',
  rivaAIIcon: iconsPath + 'riva-ai-icon.svg',
  exclamationMark: iconsPath + 'exclamation-mark.svg',
  counterClockwise: iconsPath + 'counter-clockwise.svg',
  archive: iconsPath + 'archive.svg',
  unarchive: iconsPath + 'unarchive.svg',
  imageWhite: iconsPath + 'image-white.svg',
  benchmark: iconsPath + 'c-benchmarks.svg',
  roadmap: iconsPath + 'i-roadmap.svg',
  snapshot: iconsPath + 'v-snapshot.svg',
  timer: iconsPath + 'timer.svg',
  clock: iconsPath + 'clock.svg',
  calendar: iconsPath + 'calendar.svg',
  resultsChart: iconsPath + 'resultsChart.svg',
  list: iconsPath + 'list.svg',
  answerMessage: iconsPath + 'answerMessage.svg',
};

export const IMAGES = {
  infoTooltip: imagesPath + 'info-tt.png',
};

export const LANGUAGE_ICONS = {
  en: iconsPath + 'language-en.svg',
  de: iconsPath + 'language-de.svg',
  es: iconsPath + 'language-es.svg',
};
